export const TipoMudancaEnum = Object.freeze({
  SOLICITACAO_MUDANCA: 1,
  ADICIONAR_DEPENDENTE: 2,
  REMOVER_DEPENDENTE: 3,
  CANCELAMENTO: 4,
  ADESAO: 5,
});
